import DatabaseType, { DataConnectorType } from '../domainObjects/dataConnector';
import { DataSourceType } from '../domainObjects/dataSourceType';
import { DataTypeConverter, DeduplicateRows, DurationBuilder, GeneralParameter } from '../domainObjects/ingestTransforms';
import { ColumnMapDefinitionModel } from '../model/columnMapDefinitionModel';
import { RowExclusionOption } from '../services/config/config.service';
import { DataConnectorViewModel } from './dataConnectorViewModel';

export class ImportDataViewModel {
    organizationId: number;
    name: string;
    mappingConfigId: number;
    dataConnectorType: DataConnectorType;
    databaseType: DatabaseType;
    dataConnector: DataConnectorViewModel<any>;
    columns: ColumnMapDefinitionModel[] = [];
    rowExclusions: RowExclusionOption[] = [];
    delimiters = [',', '|', 'tab'];
    delimiter = '';
    dataSourceTypeId?: DataSourceType;
    DataTypeConverter?: DataTypeConverter;
    DurationBuilder?: DurationBuilder;
    DeduplicateRows?: DeduplicateRows;
    GeneralParameter?: GeneralParameter;
}
